import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetReportsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportsQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportDocument', reportId: string, tenantId: string, name: string, description: string, dataSourceId: string, folderId?: string | null, craftJsTemplate: string, handlebarsTemplate: string, parameterValues: string, parameterConfig: string, pageSettings: string, filters: string, spreadsheetColumns: string, isStarred: boolean, appTags: Array<Types.AppTag>, status: Types.ReportStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportByIdQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ReportDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ReportDocumentSortInput> | Types.ReportDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportByIdQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportDocument', reportId: string, tenantId: string, name: string, description: string, dataSourceId: string, folderId?: string | null, craftJsTemplate: string, handlebarsTemplate: string, parameterValues: string, parameterConfig: string, pageSettings: string, filters: string, spreadsheetColumns: string, isStarred: boolean, appTags: Array<Types.AppTag>, status: Types.ReportStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ReportsByAppTagQueryVariables = Types.Exact<{
  appTag: Types.AppTag;
  where?: Types.InputMaybe<Types.ReportDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ReportDocumentSortInput> | Types.ReportDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ReportsByAppTagQuery = { __typename?: 'Query', reportsByAppTag?: { __typename?: 'ReportsByAppTagConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportDocument', reportId: string, name: string, dataSourceId: string, handlebarsTemplate: string, parameterValues: string, filters: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportFoldersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportFoldersQuery = { __typename?: 'Query', reportFolders?: { __typename?: 'ReportFoldersConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportFolderDocument', folderId: string, tenantId: string, name: string, parentId?: string | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportDataSourcesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReportDataSourcesQuery = { __typename?: 'Query', reportDataSources: Array<{ __typename?: 'ReportDataSourceDocument', id: string, name: string, description: string, category: string, queryName: string, reportTotals: Array<string>, parameters: Array<{ __typename?: 'ReportDataSourceParameter', name: string, label: string, type: string, listType?: string | null, description?: string | null, defaultValue?: string | null, isRequired: boolean, enumValues?: Array<string> | null, lookupConfig?: { __typename?: 'ReportDataSourceLookupConfig', entity: string, valueField: string, displayFields: Array<string> } | null }>, fields: Array<{ __typename?: 'ReportDataSourceField', id: string, label: string, path: string, type: string, description?: string | null, children?: Array<{ __typename?: 'ReportDataSourceField', id: string, label: string, path: string, type: string, description?: string | null, children?: Array<{ __typename?: 'ReportDataSourceField', id: string, label: string, path: string, type: string, description?: string | null }> | null }> | null, arrayItemFields?: Array<{ __typename?: 'ReportDataSourceField', id: string, label: string, path: string, type: string, description?: string | null, arrayItemFields?: Array<{ __typename?: 'ReportDataSourceField', id: string, label: string, path: string, type: string, description?: string | null }> | null }> | null }>, groupBy: Array<{ __typename?: 'ReportDataSourceGroupBy', key: string, label: string, firstRowFlag?: string | null, lastRowFlag?: string | null, requiresSort?: string | null, requiresParameter?: { __typename?: 'ReportDataSourceGroupParameter', name: string, value: string } | null, headerFields: Array<{ __typename?: 'ReportDataSourceGroupHeaderField', fieldPath: string, label: string }>, totals: Array<{ __typename?: 'ReportDataSourceGroupTotal', column: string, field: string }> }> }> };

export type GetReportTemplatesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ReportTemplateDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ReportTemplateDocumentSortInput> | Types.ReportTemplateDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportTemplatesQuery = { __typename?: 'Query', reportTemplates?: { __typename?: 'ReportTemplatesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportTemplateDocument', templateId: string, tenantId: string, name: string, description: string, category: string, tags: string, dataSourceId: string, craftJsTemplate: string, handlebarsTemplate: string, pageSettings?: string | null, parameters: string, isSystem: boolean, status: Types.ReportTemplateStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportTemplateSummariesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ReportTemplateDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ReportTemplateDocumentSortInput> | Types.ReportTemplateDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportTemplateSummariesQuery = { __typename?: 'Query', reportTemplates?: { __typename?: 'ReportTemplatesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportTemplateDocument', templateId: string, name: string, dataSourceId: string, isSystem: boolean, status: Types.ReportTemplateStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportSchedulesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportSchedulesQuery = { __typename?: 'Query', reportSchedules?: { __typename?: 'ReportSchedulesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportScheduleDocument', scheduleId: string, tenantId: string, name: string, reportId: string, reportTemplateId?: string | null, cronExpression: string, timeZoneId: string, outputFormat: string, recipients: Array<string>, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, parameters?: string | null, isActive: boolean, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, nextRunAt?: Types.TDateISO | null, lastRunAt?: Types.TDateISO | null, runOnce: boolean, orderId?: string | null, orderNumber?: string | null, docType?: Types.OrderEmailDocType | null, status: Types.ReportScheduleStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderEmailSchedulesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ReportScheduleDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ReportScheduleDocumentSortInput> | Types.ReportScheduleDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderEmailSchedulesQuery = { __typename?: 'Query', reportSchedules?: { __typename?: 'ReportSchedulesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportScheduleDocument', scheduleId: string, name: string, nextRunAt?: Types.TDateISO | null, lastRunAt?: Types.TDateISO | null, isActive: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportExecutionsQueryVariables = Types.Exact<{
  reportId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Array<Types.ReportExecutionDocumentSortInput> | Types.ReportExecutionDocumentSortInput>;
  where?: Types.InputMaybe<Types.ReportExecutionDocumentFilterInput>;
}>;


export type GetReportExecutionsQuery = { __typename?: 'Query', reportExecutions?: { __typename?: 'ReportExecutionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportExecutionDocument', id: string, executionId: string, reportId: string, executedAt: Types.TDateISO, executedBy: string, status: Types.ReportExecutionStatus, success: boolean, errorMessage?: string | null, pdfSizeBytes: number, recipientCount: number, scheduleId?: string | null, parameters?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type EmailSendRecipientFieldsFragment = { __typename?: 'EmailSendRecipientDocument', email: string, kind: Types.EmailRecipientKind, sendStatus: Types.EmailRecipientSendStatus, sendErrorMessage?: string | null, deliveryStatus: Types.EmailRecipientDeliveryStatus, deliveryReason?: string | null, bounceClassification?: string | null, statusCode?: string | null, deliveryUpdatedAt?: Types.TDateISO | null };

export type EmailSendDetailFieldsFragment = { __typename?: 'EmailSendDocument', id: string, emailSendId: string, source: Types.EmailSendSource, reportId?: string | null, scheduleId?: string | null, orderId?: string | null, orderNumber?: string | null, docType?: string | null, subject: string, fromEmail: string, fromName?: string | null, sendGridMessageId?: string | null, pdfSizeBytes?: number | null, sentBy: string, sentAt: Types.TDateISO, deliveryStatus: Types.EmailDeliveryStatus, channel?: Types.EmailSenderChannel | null, recipients: Array<{ __typename?: 'EmailSendRecipientDocument', email: string, kind: Types.EmailRecipientKind, sendStatus: Types.EmailRecipientSendStatus, sendErrorMessage?: string | null, deliveryStatus: Types.EmailRecipientDeliveryStatus, deliveryReason?: string | null, bounceClassification?: string | null, statusCode?: string | null, deliveryUpdatedAt?: Types.TDateISO | null }> };

export type GetEmailSendsQueryVariables = Types.Exact<{
  orderId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderNumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  reportId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  scheduleId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.EmailSendDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.EmailSendDocumentSortInput> | Types.EmailSendDocumentSortInput>;
}>;


export type GetEmailSendsQuery = { __typename?: 'Query', emailSends?: { __typename?: 'EmailSendsConnection', totalCount: number, nodes?: Array<{ __typename?: 'EmailSendDocument', id: string, emailSendId: string, source: Types.EmailSendSource, reportId?: string | null, scheduleId?: string | null, orderId?: string | null, orderNumber?: string | null, docType?: string | null, subject: string, fromEmail: string, fromName?: string | null, sendGridMessageId?: string | null, pdfSizeBytes?: number | null, sentBy: string, sentAt: Types.TDateISO, deliveryStatus: Types.EmailDeliveryStatus, channel?: Types.EmailSenderChannel | null, recipients: Array<{ __typename?: 'EmailSendRecipientDocument', email: string, kind: Types.EmailRecipientKind, sendStatus: Types.EmailRecipientSendStatus, sendErrorMessage?: string | null, deliveryStatus: Types.EmailRecipientDeliveryStatus, deliveryReason?: string | null, bounceClassification?: string | null, statusCode?: string | null, deliveryUpdatedAt?: Types.TDateISO | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GenerateReportPdfQueryVariables = Types.Exact<{
  reportId: Types.Scalars['String']['input'];
  parameters?: Types.InputMaybe<Types.Scalars['String']['input']>;
  headerHtml?: Types.InputMaybe<Types.Scalars['String']['input']>;
  footerHtml?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GenerateReportPdfQuery = { __typename?: 'Query', generateReportPdf: { __typename?: 'ReportPdfPayload', success: boolean, pdfBase64?: string | null, errorMessage?: string | null } };

export type GenerateReportCsvQueryVariables = Types.Exact<{
  reportId: Types.Scalars['String']['input'];
  parameters?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GenerateReportCsvQuery = { __typename?: 'Query', generateReportCsv: { __typename?: 'ReportCsvPayload', success: boolean, csvBase64?: string | null, errorMessage?: string | null } };

export type GenerateReportExcelQueryVariables = Types.Exact<{
  reportId: Types.Scalars['String']['input'];
  parameters?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GenerateReportExcelQuery = { __typename?: 'Query', generateReportExcel: { __typename?: 'ReportExcelPayload', success: boolean, excelBase64?: string | null, errorMessage?: string | null } };

export type GetReportVersionsQueryVariables = Types.Exact<{
  reportId: Types.Scalars['String']['input'];
}>;


export type GetReportVersionsQuery = { __typename?: 'Query', reportVersions: Array<{ __typename?: 'ReportVersionRecord', version: number, eventId: string, eventType: string, name: string, description: string, dataSourceId: string, folderId?: string | null, craftJsTemplate: string, handlebarsTemplate: string, parameterValues: string, parameterConfig: string, pageSettings: string, filters: string, isStarred: boolean, updatedBy: string, updatedAt: Types.TDateISO }> };

export type GetEmailSendDetailQueryVariables = Types.Exact<{
  where: Types.EmailSendDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetEmailSendDetailQuery = { __typename?: 'Query', emailSends?: { __typename?: 'EmailSendsConnection', nodes?: Array<{ __typename?: 'EmailSendDocument', id: string, emailSendId: string, source: Types.EmailSendSource, reportId?: string | null, scheduleId?: string | null, orderId?: string | null, orderNumber?: string | null, docType?: string | null, subject: string, fromEmail: string, fromName?: string | null, sendGridMessageId?: string | null, pdfSizeBytes?: number | null, sentBy: string, sentAt: Types.TDateISO, deliveryStatus: Types.EmailDeliveryStatus, channel?: Types.EmailSenderChannel | null, recipients: Array<{ __typename?: 'EmailSendRecipientDocument', email: string, kind: Types.EmailRecipientKind, sendStatus: Types.EmailRecipientSendStatus, sendErrorMessage?: string | null, deliveryStatus: Types.EmailRecipientDeliveryStatus, deliveryReason?: string | null, bounceClassification?: string | null, statusCode?: string | null, deliveryUpdatedAt?: Types.TDateISO | null }> }> | null } | null };

export type GetReportNamesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReportNamesQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportDocument', reportId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReportCurrentVersionQueryVariables = Types.Exact<{
  reportId: Types.Scalars['String']['input'];
}>;


export type GetReportCurrentVersionQuery = { __typename?: 'Query', reportVersions: Array<{ __typename?: 'ReportVersionRecord', version: number }> };

export type ReportExecutionDocumentFieldsFragment = { __typename?: 'ReportExecutionDocument', executionId: string, reportId: string, reportName?: string | null, scheduleId?: string | null, orderId?: string | null, reportVersion?: number | null, executedBy: string, executedAt: Types.TDateISO, parameters?: string | null, success: boolean, errorMessage?: string | null, pdfSizeBytes: number, artifactSha256?: string | null };

export type GetReportExecutionByIdQueryVariables = Types.Exact<{
  where: Types.ReportExecutionDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetReportExecutionByIdQuery = { __typename?: 'Query', reportExecutions?: { __typename?: 'ReportExecutionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportExecutionDocument', executionId: string, reportId: string, reportName?: string | null, scheduleId?: string | null, orderId?: string | null, reportVersion?: number | null, executedBy: string, executedAt: Types.TDateISO, parameters?: string | null, success: boolean, errorMessage?: string | null, pdfSizeBytes: number, artifactSha256?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const EmailSendRecipientFieldsFragmentDoc = new TypedDocumentString(`
    fragment EmailSendRecipientFields on EmailSendRecipientDocument {
  email
  kind
  sendStatus
  sendErrorMessage
  deliveryStatus
  deliveryReason
  bounceClassification
  statusCode
  deliveryUpdatedAt
}
    `, {"fragmentName":"EmailSendRecipientFields"});
export const EmailSendDetailFieldsFragmentDoc = new TypedDocumentString(`
    fragment EmailSendDetailFields on EmailSendDocument {
  id
  emailSendId
  source
  reportId
  scheduleId
  orderId
  orderNumber
  docType
  subject
  fromEmail
  fromName
  sendGridMessageId
  pdfSizeBytes
  sentBy
  sentAt
  deliveryStatus
  channel
  recipients {
    ...EmailSendRecipientFields
  }
}
    fragment EmailSendRecipientFields on EmailSendRecipientDocument {
  email
  kind
  sendStatus
  sendErrorMessage
  deliveryStatus
  deliveryReason
  bounceClassification
  statusCode
  deliveryUpdatedAt
}`, {"fragmentName":"EmailSendDetailFields"});
export const ReportExecutionDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportExecutionDocumentFields on ReportExecutionDocument {
  executionId
  reportId
  reportName
  scheduleId
  orderId
  reportVersion
  executedBy
  executedAt
  parameters
  success
  errorMessage
  pdfSizeBytes
  artifactSha256
}
    `, {"fragmentName":"ReportExecutionDocumentFields"});
export const GetReportsDocument = new TypedDocumentString(`
    query GetReports($first: Int, $after: String) {
  reports(first: $first, after: $after) {
    nodes {
      reportId
      tenantId
      name
      description
      dataSourceId
      folderId
      craftJsTemplate
      handlebarsTemplate
      parameterValues
      parameterConfig
      pageSettings
      filters
      spreadsheetColumns
      isStarred
      appTags
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportByIdDocument = new TypedDocumentString(`
    query GetReportById($where: ReportDocumentFilterInput, $order: [ReportDocumentSortInput!], $first: Int, $after: String) {
  reports(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      reportId
      tenantId
      name
      description
      dataSourceId
      folderId
      craftJsTemplate
      handlebarsTemplate
      parameterValues
      parameterConfig
      pageSettings
      filters
      spreadsheetColumns
      isStarred
      appTags
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const ReportsByAppTagDocument = new TypedDocumentString(`
    query ReportsByAppTag($appTag: AppTag!, $where: ReportDocumentFilterInput, $order: [ReportDocumentSortInput!], $first: Int, $after: String) {
  reportsByAppTag(
    appTag: $appTag
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      reportId
      name
      dataSourceId
      handlebarsTemplate
      parameterValues
      filters
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportFoldersDocument = new TypedDocumentString(`
    query GetReportFolders($first: Int, $after: String) {
  reportFolders(first: $first, after: $after) {
    nodes {
      folderId
      tenantId
      name
      parentId
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportDataSourcesDocument = new TypedDocumentString(`
    query GetReportDataSources {
  reportDataSources {
    id
    name
    description
    category
    queryName
    parameters {
      name
      label
      type
      listType
      description
      defaultValue
      isRequired
      enumValues
      lookupConfig {
        entity
        valueField
        displayFields
      }
    }
    fields {
      id
      label
      path
      type
      description
      children {
        id
        label
        path
        type
        description
        children {
          id
          label
          path
          type
          description
        }
      }
      arrayItemFields {
        id
        label
        path
        type
        description
        arrayItemFields {
          id
          label
          path
          type
          description
        }
      }
    }
    reportTotals
    groupBy {
      key
      label
      firstRowFlag
      lastRowFlag
      requiresSort
      requiresParameter {
        name
        value
      }
      headerFields {
        fieldPath
        label
      }
      totals {
        column
        field
      }
    }
  }
}
    `);
export const GetReportTemplatesDocument = new TypedDocumentString(`
    query GetReportTemplates($where: ReportTemplateDocumentFilterInput, $order: [ReportTemplateDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  reportTemplates(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      templateId
      tenantId
      name
      description
      category
      tags
      dataSourceId
      craftJsTemplate
      handlebarsTemplate
      pageSettings
      parameters
      isSystem
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportTemplateSummariesDocument = new TypedDocumentString(`
    query GetReportTemplateSummaries($where: ReportTemplateDocumentFilterInput, $order: [ReportTemplateDocumentSortInput!], $first: Int, $after: String) {
  reportTemplates(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      templateId
      name
      dataSourceId
      isSystem
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportSchedulesDocument = new TypedDocumentString(`
    query GetReportSchedules($first: Int, $after: String) {
  reportSchedules(first: $first, after: $after) {
    nodes {
      scheduleId
      tenantId
      name
      reportId
      reportTemplateId
      cronExpression
      timeZoneId
      outputFormat
      recipients
      emailSubject
      emailBody
      senderId
      parameters
      isActive
      startDate
      endDate
      nextRunAt
      lastRunAt
      runOnce
      orderId
      orderNumber
      docType
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderEmailSchedulesDocument = new TypedDocumentString(`
    query GetOrderEmailSchedules($where: ReportScheduleDocumentFilterInput, $order: [ReportScheduleDocumentSortInput!], $first: Int, $after: String) {
  reportSchedules(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      scheduleId
      name
      nextRunAt
      lastRunAt
      isActive
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportExecutionsDocument = new TypedDocumentString(`
    query GetReportExecutions($reportId: String, $first: Int, $after: String, $order: [ReportExecutionDocumentSortInput!], $where: ReportExecutionDocumentFilterInput) {
  reportExecutions(
    reportId: $reportId
    first: $first
    after: $after
    order: $order
    where: $where
  ) {
    nodes {
      id
      executionId
      reportId
      executedAt
      executedBy
      status
      success
      errorMessage
      pdfSizeBytes
      recipientCount
      scheduleId
      parameters
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetEmailSendsDocument = new TypedDocumentString(`
    query GetEmailSends($orderId: String, $orderNumber: String, $reportId: String, $scheduleId: String, $first: Int, $after: String, $where: EmailSendDocumentFilterInput, $order: [EmailSendDocumentSortInput!]) {
  emailSends(
    orderId: $orderId
    orderNumber: $orderNumber
    reportId: $reportId
    scheduleId: $scheduleId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...EmailSendDetailFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment EmailSendRecipientFields on EmailSendRecipientDocument {
  email
  kind
  sendStatus
  sendErrorMessage
  deliveryStatus
  deliveryReason
  bounceClassification
  statusCode
  deliveryUpdatedAt
}
fragment EmailSendDetailFields on EmailSendDocument {
  id
  emailSendId
  source
  reportId
  scheduleId
  orderId
  orderNumber
  docType
  subject
  fromEmail
  fromName
  sendGridMessageId
  pdfSizeBytes
  sentBy
  sentAt
  deliveryStatus
  channel
  recipients {
    ...EmailSendRecipientFields
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GenerateReportPdfDocument = new TypedDocumentString(`
    query GenerateReportPdf($reportId: String!, $parameters: String, $headerHtml: String, $footerHtml: String) {
  generateReportPdf(
    reportId: $reportId
    parameters: $parameters
    headerHtml: $headerHtml
    footerHtml: $footerHtml
  ) {
    success
    pdfBase64
    errorMessage
  }
}
    `);
export const GenerateReportCsvDocument = new TypedDocumentString(`
    query GenerateReportCsv($reportId: String!, $parameters: String) {
  generateReportCsv(reportId: $reportId, parameters: $parameters) {
    success
    csvBase64
    errorMessage
  }
}
    `);
export const GenerateReportExcelDocument = new TypedDocumentString(`
    query GenerateReportExcel($reportId: String!, $parameters: String) {
  generateReportExcel(reportId: $reportId, parameters: $parameters) {
    success
    excelBase64
    errorMessage
  }
}
    `);
export const GetReportVersionsDocument = new TypedDocumentString(`
    query GetReportVersions($reportId: String!) {
  reportVersions(reportId: $reportId) {
    version
    eventId
    eventType
    name
    description
    dataSourceId
    folderId
    craftJsTemplate
    handlebarsTemplate
    parameterValues
    parameterConfig
    pageSettings
    filters
    isStarred
    updatedBy
    updatedAt
  }
}
    `);
export const GetEmailSendDetailDocument = new TypedDocumentString(`
    query GetEmailSendDetail($where: EmailSendDocumentFilterInput!, $first: Int!) {
  emailSends(where: $where, first: $first) {
    nodes {
      ...EmailSendDetailFields
    }
  }
}
    fragment EmailSendRecipientFields on EmailSendRecipientDocument {
  email
  kind
  sendStatus
  sendErrorMessage
  deliveryStatus
  deliveryReason
  bounceClassification
  statusCode
  deliveryUpdatedAt
}
fragment EmailSendDetailFields on EmailSendDocument {
  id
  emailSendId
  source
  reportId
  scheduleId
  orderId
  orderNumber
  docType
  subject
  fromEmail
  fromName
  sendGridMessageId
  pdfSizeBytes
  sentBy
  sentAt
  deliveryStatus
  channel
  recipients {
    ...EmailSendRecipientFields
  }
}`);
export const GetReportNamesDocument = new TypedDocumentString(`
    query GetReportNames($first: Int, $after: String) {
  reports(first: $first, after: $after) {
    nodes {
      reportId
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReportCurrentVersionDocument = new TypedDocumentString(`
    query GetReportCurrentVersion($reportId: String!) {
  reportVersions(reportId: $reportId) {
    version
  }
}
    `);
export const GetReportExecutionByIdDocument = new TypedDocumentString(`
    query GetReportExecutionById($where: ReportExecutionDocumentFilterInput!, $first: Int!) {
  reportExecutions(where: $where, first: $first) {
    nodes {
      ...ReportExecutionDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ReportExecutionDocumentFields on ReportExecutionDocument {
  executionId
  reportId
  reportName
  scheduleId
  orderId
  reportVersion
  executedBy
  executedAt
  parameters
  success
  errorMessage
  pdfSizeBytes
  artifactSha256
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetReports: build.query<GetReportsQuery, GetReportsQueryVariables | void>({
      query: (variables) => ({ document: GetReportsDocument, variables })
    }),
    GetReportById: build.query<GetReportByIdQuery, GetReportByIdQueryVariables | void>({
      query: (variables) => ({ document: GetReportByIdDocument, variables })
    }),
    ReportsByAppTag: build.query<ReportsByAppTagQuery, ReportsByAppTagQueryVariables>({
      query: (variables) => ({ document: ReportsByAppTagDocument, variables })
    }),
    GetReportFolders: build.query<GetReportFoldersQuery, GetReportFoldersQueryVariables | void>({
      query: (variables) => ({ document: GetReportFoldersDocument, variables })
    }),
    GetReportDataSources: build.query<GetReportDataSourcesQuery, GetReportDataSourcesQueryVariables | void>({
      query: (variables) => ({ document: GetReportDataSourcesDocument, variables })
    }),
    GetReportTemplates: build.query<GetReportTemplatesQuery, GetReportTemplatesQueryVariables | void>({
      query: (variables) => ({ document: GetReportTemplatesDocument, variables })
    }),
    GetReportTemplateSummaries: build.query<GetReportTemplateSummariesQuery, GetReportTemplateSummariesQueryVariables | void>({
      query: (variables) => ({ document: GetReportTemplateSummariesDocument, variables })
    }),
    GetReportSchedules: build.query<GetReportSchedulesQuery, GetReportSchedulesQueryVariables | void>({
      query: (variables) => ({ document: GetReportSchedulesDocument, variables })
    }),
    GetOrderEmailSchedules: build.query<GetOrderEmailSchedulesQuery, GetOrderEmailSchedulesQueryVariables | void>({
      query: (variables) => ({ document: GetOrderEmailSchedulesDocument, variables })
    }),
    GetReportExecutions: build.query<GetReportExecutionsQuery, GetReportExecutionsQueryVariables | void>({
      query: (variables) => ({ document: GetReportExecutionsDocument, variables })
    }),
    GetEmailSends: build.query<GetEmailSendsQuery, GetEmailSendsQueryVariables | void>({
      query: (variables) => ({ document: GetEmailSendsDocument, variables })
    }),
    GenerateReportPdf: build.query<GenerateReportPdfQuery, GenerateReportPdfQueryVariables>({
      query: (variables) => ({ document: GenerateReportPdfDocument, variables })
    }),
    GenerateReportCsv: build.query<GenerateReportCsvQuery, GenerateReportCsvQueryVariables>({
      query: (variables) => ({ document: GenerateReportCsvDocument, variables })
    }),
    GenerateReportExcel: build.query<GenerateReportExcelQuery, GenerateReportExcelQueryVariables>({
      query: (variables) => ({ document: GenerateReportExcelDocument, variables })
    }),
    GetReportVersions: build.query<GetReportVersionsQuery, GetReportVersionsQueryVariables>({
      query: (variables) => ({ document: GetReportVersionsDocument, variables })
    }),
    GetEmailSendDetail: build.query<GetEmailSendDetailQuery, GetEmailSendDetailQueryVariables>({
      query: (variables) => ({ document: GetEmailSendDetailDocument, variables })
    }),
    GetReportNames: build.query<GetReportNamesQuery, GetReportNamesQueryVariables | void>({
      query: (variables) => ({ document: GetReportNamesDocument, variables })
    }),
    GetReportCurrentVersion: build.query<GetReportCurrentVersionQuery, GetReportCurrentVersionQueryVariables>({
      query: (variables) => ({ document: GetReportCurrentVersionDocument, variables })
    }),
    GetReportExecutionById: build.query<GetReportExecutionByIdQuery, GetReportExecutionByIdQueryVariables>({
      query: (variables) => ({ document: GetReportExecutionByIdDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetReportsQuery, useLazyGetReportsQuery, useGetReportByIdQuery, useLazyGetReportByIdQuery, useReportsByAppTagQuery, useLazyReportsByAppTagQuery, useGetReportFoldersQuery, useLazyGetReportFoldersQuery, useGetReportDataSourcesQuery, useLazyGetReportDataSourcesQuery, useGetReportTemplatesQuery, useLazyGetReportTemplatesQuery, useGetReportTemplateSummariesQuery, useLazyGetReportTemplateSummariesQuery, useGetReportSchedulesQuery, useLazyGetReportSchedulesQuery, useGetOrderEmailSchedulesQuery, useLazyGetOrderEmailSchedulesQuery, useGetReportExecutionsQuery, useLazyGetReportExecutionsQuery, useGetEmailSendsQuery, useLazyGetEmailSendsQuery, useGenerateReportPdfQuery, useLazyGenerateReportPdfQuery, useGenerateReportCsvQuery, useLazyGenerateReportCsvQuery, useGenerateReportExcelQuery, useLazyGenerateReportExcelQuery, useGetReportVersionsQuery, useLazyGetReportVersionsQuery, useGetEmailSendDetailQuery, useLazyGetEmailSendDetailQuery, useGetReportNamesQuery, useLazyGetReportNamesQuery, useGetReportCurrentVersionQuery, useLazyGetReportCurrentVersionQuery, useGetReportExecutionByIdQuery, useLazyGetReportExecutionByIdQuery } = injectedRtkApi;
